import * as utils from '@/components/utils';
import { S2S_CLIENT_ID } from '@/config/constants';
import { S2STokenRes } from './type';
import moment from 'moment';
import { sbaas_mdr_api } from '@/config/sbaas';

export const generateJwtToken = async () => {
  const res = await sbaas_mdr_api.script('generate_jwt_token').get();
  return res.data;
};

export const getS2SToken = async () => {
  const times = parseInt(utils.getStorage('S2S_D') || '0');
  const accessToken = utils.getStorage('S2S_T');
  const dt = moment(times)
    .toDate()
    .getTime();
  const at = moment()
    .subtract(59, 'minute')
    .toDate()
    .getTime();
  let resultToken: string = '';
  if (dt > at && accessToken) {
    resultToken = accessToken;
  } else {
    const token = await generateJwtToken();
    const res = await sbaas_mdr_api.script('s2s_token').post({
      body: {
        assertion: token.data,
        clientId: S2S_CLIENT_ID,
      },
    });
    const data = res.data as S2STokenRes;
    resultToken = data.res.acstokenres.access_token;
    utils.setStorage('S2S_T', resultToken);
    utils.setStorage(
      'S2S_D',
      moment()
        .toDate()
        .getTime()
        .toString(),
    );
  }
  return resultToken;
};
